import { FormText } from "reactstrap"

import { IGoal } from "@api/schema"
import Icon from '@components/common/Icon'

interface IProps {
  goal: IGoal
}

/**
 * provides a single card to show a project goal with its measurability
 */
const GoalCard: React.FC<IProps> = (props: IProps) => {
  const { goal } = props

  return <div className="non-action-icon--left multi-input-array--view">
    <Icon name="goal" size={25} />
    <div>
      <p>{goal.goal}</p>
      <FormText>
        {goal.measurability}
      </FormText>
    </div>

  </div>

}

export default GoalCard